<template src="./withdrawGift.html"></template>

<script>
export default {
  name: 'WithdrawGift',
  components: {},
  data() {
    return {
      code: '',
      allowed: false,
      processing: false,
    };
  },
  computed: {},
  watch: {
    code() {
      if (this.code.length > 8) {
        this.allowed = true;
      } else {
        this.allowed = false;
      }
    },
  },
  created() {},
  destroyed() {},
  methods: {
    withDraw() {
      if (this.code && !this.processing) {
        this.processing = true;
        const tokenStr = Cookies.get('token');

        this.$MS_SOCO_PUBLIC_API_URL
          .get(`offlinestore/store-cms/withdraw/${this.code}`, { headers: { Authorization: `Bearer ${tokenStr}` } })
          .then((response) => {
            if (response.status == 200) {
              this.code = '';
              this.$store.commit('setProductsVm', response.data.data);
              this.processing = false;
              this.$router.push('/vending-machine/product');
            }
          })
          .catch((err) => {
            if (err.message == 'Network Error') {
              this.$toasted.global.error('Voucher not valid.');
            } else {
              this.$toasted.global.error('Please try again later.');
            }
            this.code = '';
            this.processing = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'withdrawGift';
</style>
